import { v4 as uuid } from 'uuid';
const DEFAULT_TOP_K = 8;

function resolveObject(value) {
  return (
    value
    && typeof value === 'object'
    && !Array.isArray(value)
  ) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function resolvePositiveInteger(value, fallback) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return fallback;
  }
  return Math.floor(numeric);
}

function firstText(values, fallback = '') {
  const selected = values.find(Boolean);
  return String(selected || fallback).trim() || fallback;
}

export function selectLatestSourcingPayload(timelineItems = []) {
  const item = [...resolveArray(timelineItems)]
    .reverse()
    .find((entry) => String(entry?.type || '').trim() === 'sourcing_candidates');
  return resolveObject(item?.payload);
}

export function resolveSourcingResultIds(payload = {}) {
  return resolveArray(payload?.candidates)
    .map((item) => String(item?.result_id || item?.id || item?.supplier_id || '').trim())
    .filter(Boolean);
}

export function buildSourcingSearchRequest(options) {
  const {
    activeSessionId,
    latestPayload,
    loadedTopK,
    maxTopK,
    projectId,
    resultIds,
    userId,
  } = {
    activeSessionId: '',
    latestPayload: {},
    loadedTopK: DEFAULT_TOP_K,
    maxTopK: 100,
    projectId: '',
    resultIds: [],
    userId: '',
    ...options,
  };
  const payload = resolveObject(latestPayload);
  const currentTopK = resolvePositiveInteger(payload.requested_top_k, loadedTopK);
  const fallbackTopK = Math.min(resolvePositiveInteger(maxTopK, 100), currentTopK + DEFAULT_TOP_K);
  const nextTopK = resolvePositiveInteger(payload.next_top_k, fallbackTopK);
  const query = firstText([payload.query, payload.message_excerpt]);
  const resolvedMaxTopK = resolvePositiveInteger(maxTopK, 100);
  return {
    client_request_id: options?.clientRequestId ?? uuid(),
    project_id: firstText([projectId, payload.project_id], 'default'),
    user_id: firstText([userId, payload.user_id], 'default'),
    session_id: firstText([activeSessionId, payload.session_id], 'default'),
    query,
    top_k: Math.min(resolvedMaxTopK, nextTopK),
    append_mode: true,
    lock_existing_order: true,
    base_result_ids: resolveArray(resultIds).filter(Boolean),
    source_scope: firstText([payload.source_scope], 'hybrid'),
    sourcing_enabled: true,
    context_refs: resolveArray(payload.context_refs),
    knowledge_refs: resolveArray(payload.knowledge_refs),
    source_ids: resolveArray(payload.source_ids).map((item) => firstText([item])).filter(Boolean),
    entities: resolveArray(payload.entities),
    entity_query_mode: firstText([payload.entity_query_mode], 'prefer'),
  };
}

export function buildSourcingSearchTimelineItems(response = {}) {
  const payload = resolveObject(response);
  const runId = String(payload.retrieval_run_id || payload.run_id || payload.trace_id || 'latest').trim();
  const candidates = resolveArray(payload.results);
  const sourcingPayload = {
    ...payload,
    run_id: runId,
    retrieval_run_id: runId,
    candidates,
  };
  const items = [{
    id: `sourcing-candidates-api-${runId}`,
    type: 'sourcing_candidates',
    payload: sourcingPayload,
  }];
  const canvasState = resolveObject(payload.canvas_state);
  if (Object.keys(canvasState).length > 0) {
    items.push({
      id: `sourcing-canvas-api-${runId}`,
      type: 'canvas_state',
      payload: canvasState,
    });
  }
  return items;
}
